<template>
  <div class="commonDialogBody">
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
        :visible.sync="dialogVisible"
        width="40%"
        :before-close="handleClose">
        <div class="hint">
            <span class="hintSpan">温馨提示：</span><span class="HintSpanA">单击标签可添加或去除选择项；拖拽右侧标签可更改排序；最多可选择6项。</span>
        </div>
            <div class="itxst">
                <p>已展示模块项:</p>
                <br/>
                <div class="col">
                    <draggable v-model="RapidList" :scroll="true" animation="300">
                        <transition-group>
                            <div @click="sadasd()" :class="item.id==1?'itemS forbid':'itemS'" v-for="item in RapidList" :key="item.id">
                                    <div class="itemSimg">
                                        <img :src="item.img" alt="" style="width:100%;height:100%">
                                    </div>
                                    {{item.name}}
                                    <el-tooltip  effect="dark" content="可拖动排序" placement="bottom" style="z-index:3000;cursor:pointer;float:right;line-height: 50px;width:30px;height:30px">
                                        <span>
                                            <i class="el-icon-s-operation tooltip"><span class="tooltiptext" style="margin-top:-35px;margin-left:-47px;">可拖动排序</span></i>
                                        </span>
                                    </el-tooltip>
                                    <el-tooltip  effect="dark" content="点击删除" placement="bottom" style="z-index:3000;cursor:pointer;float:right;line-height: 50px;width:30px;height:30px">
                                       <span>
                                           <i class="el-icon-delete tooltip" @click.stop="dele(item)"><span class="tooltiptext" style="margin-top:-35px;margin-left:-47px;">点击删除</span></i>
                                       </span>
                                    </el-tooltip>
                            </div>
                        </transition-group>
                    </draggable> 
                </div>
            </div>
            <br/>
            <p>已选择模块项:</p>
            <br/>
            <div style="width:90%;height:300px;border:1px solid #EAEDF1;border-radius: 5px;margin-left:9px;padding:10px">
                <div style="width:10%;height:70px;float: left;text-align: center;margin-left:35px" v-for="item in RapidData" :key="item.id">

                    <el-checkbox  :disabled="item.discheck" :id="item.id" style="float:right;" :true-label="item.id" @change="disabox"></el-checkbox>
                    <div style="width:35px;height:35px;margin-left:13px;margin-bottom:10px">
                         <img :src="item.img" alt="" style="width:100%;height:100%">
                    </div>
                    <span style="font-size:14px;">{{item.name}}</span>
                </div>
            </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modification()" v-debounce>确 定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
export default {
 components: {draggable},
  name: "HomeDialog",
  data() {
    return {
        dialogVisible: false,
        title:"标题",
        RapidList:[],
        RapidData:[],
        drag:false,
        discheck:false,
        alter:false,
        arrayList:[],
    };
  },
    watch: {
        alter(val){
            if(val == true){
                var a = this.RapidList; var b = this.RapidData;
                let arr = []; let array = [];
                for(let val of a){ arr.push(val.id) }; for(let res of b){ array.push(res.id)};
                let list = Array.from(new Set(this.getArrDifference(arr,array)))
                for(let val of b){
                    for(let res of list){
                        if(val.id === res){
                            val.discheck = true
                        }
                    }
                }
            }
        },
    },
  methods: {
        getArrDifference(arr1, arr2) {
            return arr1.concat(arr2).filter(function(v, i, arr) {
                return arr.indexOf(v) != arr.lastIndexOf(v);
            });
        },
    disabox(id){
        let arr = []
        if(id != false){
            for(let val of this.RapidData){
                if(val.id == id){
                    this.arrayList.push(val)
                    this.alter = false
                    this.alter = true
                }
            }
        }
    },
    modification(){
        let arr = []
        if(this.RapidList.length > 6 || this.RapidList.length == 6){
            // 提示
        }else{
            for(let val of this.arrayList){
                this.RapidList.push(val)
            }
            if(this.RapidList.length > 6 || this.RapidList.length == 6){
                // 提示
            }else{

            }
            
        }
        this.dialogVisible = false
        this.$emit("Rapid",this.RapidList)
    },
    handleClose(done) {
      this.dialogVisible = false
    },
    dele(item){
    this.$confirm('您确认要删除当前菜单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
        }).then(() => {
            this.$message({
                type: 'success',
                message: '删除成功!'
            });

            this.RapidList.forEach(function(val, index, arr) {
                if(val.id == item.id) {
                    val.discheck = false
                    arr.splice(index, 1);
                }
            });
        this.alter = false
        this.alter = true
        }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消删除'
            });          
        }); 
    },
    sadasd(){
        console.log(this.drag)
    },
    events(){

    },
  },
    //组件创建之后
  created() {

  },
    //页面渲染之前
  beforeMount() {
   
  },
  mounted() {
  }
}
</script>

<style scoped lang="scss">
.navigation{
    width: 100%;
    height: 400px;
    border: 1px solid;
}
      .itxst {
           width: 110%;
           margin: 10px;
           text-align :left;
           height: 400px;
           overflow: auto;
      }
      .col {
          width: 90%;
          flex: 1;
          padding: 20px;
          border: solid 1px #eee;
          border-radius: 5px;
          float: left;
          
      }
      .col + .col {
          margin-left: 10px;
      }
      .itemS {
        //   padding: 20px 12px;
        //   margin: 0px 10px 0px 10px;
        width: 100%;
        height: 50px;
        line-height: 50px;
          border: solid 1px #eee;
          background-color: #fff;
          text-align: left;
      }
      .itemS + .itemS {
          border-top: none;
          margin-top: 6px;
      }
      .itemS:hover {
          background-color: #f1f1f1;
          cursor: move;
      } 
      .itemSimg{
          width: 48px;
          height: 48px;
          float: left;
          margin-right: 10px;
      }

    .Wdrag{
        width: 100%;
        height: 60px;
        line-height: 60px;
        border: 1px solid;
        .Ndrag{
            width: 80%;
            height: 60px;
            line-height: 60px;
            border: 1px solid;
            float: left;
        }
        .item{
            float: right;
            border: 1px solid;
            width: 25px;
            height: 25px;
        }
    }
    .tooltip {
    position: relative;
    display: inline-block;
}
    .tooltip:hover .tooltiptext {
        visibility: visible;
    }
    .tooltip .tooltiptext {
        visibility: hidden;
        width: 80px;
        font-size: 13px;
        background-color: RGBA(53, 54, 56, 0.8);
        color: #fff;
        text-align: center;
        border-radius: 6px;
        padding: 5px 0;
        position: absolute;
        z-index: 1;
    }
    .tooltip .tooltiptext::after {
    content: " ";
    position: absolute;
    top: 100%; /* 提示工具底部 */
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: RGBA(53, 54, 56, 0.8) transparent transparent transparent;
}
    .tooltip .tooltiptext {
    opacity: 0;
    transition: opacity 1s;
}
 
.tooltip:hover .tooltiptext {
    opacity: 1;
}
.hint{
    width: 602px;
    height: 40px;
    background: #E6F7FF;
    border-radius: 2px;
    border: 1px solid #91D5FF;
    margin: auto;
    line-height: 40px;
    text-align:center;
    -moz-user-select: none;
    -khtml-user-select: none;
    user-select: none;
    .hintSpan{
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #246CE5;
    }
    .HintSpanA{
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
    }
}
    
</style>